import {
  useQuery,
  useLazyQuery,
  useMutation
} from "@apollo/client";

import {
  GET_FORM,
  GET_FORM_BY_MILL,
  // GET_INSPECT_OPTION,
  // GET_INSPECT_RESULT,
  GET_HISTORY,
  GET_HISTORY_BY_ID,
  GET_HISTORY_BY_SHARE_ID,
  GET_INFERENCE_BY_ID,
  CREATE_LIST_INSPECT_RESULT,
  GET_USER_PROFILE,
  UPDATE_USER_PROFILE,
  DELETE_INSPECT_RESULT,
  UPDATE_INSPECT_RESULT,
  GET_EVODATA,
  // GET_INSPECT_STANDARD_OPTION,
  SHARE_STATUS_RESULT,
  GET_VIEW_STANDARD,
  CREATE_SHARE_STANDARD,
  GET_IMAGE_COLOR_INFERENCE,
  EDIT_STANDARD,
  UPDATE_USER_FLAG,
  UPDATE_USER_FLAG_NEW_FEATURE,
  GET_USER_PROFILE_PACKAGE,
  GET_LIST_ROLE,
  GET_ROLE_BY_ID,
} from "../queries";
import { GetInspectOptionDocument, GetInspectStandardDocument } from "__generated__/graphql";

export const useGetInspectOption = (options) =>
  useQuery(GetInspectOptionDocument, options);

export const useGetFormByMill = (options) =>
  useQuery(GET_FORM_BY_MILL, options);

export const useLazyGetInspectStandard = (options) =>
  useLazyQuery(GetInspectStandardDocument, options);

export const useGetEvoData = (options) => useQuery(GET_EVODATA, options);
export const useLazyGetEvoData = (options) =>
  useLazyQuery(GET_EVODATA, options);

// export const useGetInspectResult = options => useQuery(GET_INSPECT_RESULT, options);
export const useGetHistoryById = (options) =>
  useQuery(GET_HISTORY_BY_ID, options);
export const useLazyGetHistoryById = (options) =>
  useLazyQuery(GET_HISTORY_BY_ID, options);
export const useLazyGetHistoryByShareId = (options) =>
  useLazyQuery(GET_HISTORY_BY_SHARE_ID, options);
export const useGetHistory = (options) =>
  useQuery(GET_HISTORY, options);
export const useLazyGetHistory = (options) =>
  useLazyQuery(GET_HISTORY, options);
export const useCreateInspectResult = () =>
  useMutation(CREATE_LIST_INSPECT_RESULT);
export const useUpdateInspectResult = () => useMutation(UPDATE_INSPECT_RESULT);

export const useUpdateShareStatusInspectResult = () =>
  useMutation(SHARE_STATUS_RESULT);

export const useGetInferenceById = (options) =>
  useQuery(GET_INFERENCE_BY_ID, options);
export const useLazyGetInferenceById = (options) =>
  useLazyQuery(GET_INFERENCE_BY_ID, options);

export const useLazyGetUserProfile = (options) =>
  useLazyQuery(GET_USER_PROFILE, options);
export const useGetUserProfilePackage = (options) =>
  useQuery(GET_USER_PROFILE_PACKAGE, options);
export const useLazyGetUserProfilePackage = (options) =>
  useLazyQuery(GET_USER_PROFILE_PACKAGE, options);
export const useUpdateUserProfile = (options) =>
  useMutation(UPDATE_USER_PROFILE, options);

export const useUpdateUserFlag = (options=null) =>
  useMutation(UPDATE_USER_FLAG, options);
export const useUpdateUserFlagNewFeature = (options=null) =>
  useMutation(UPDATE_USER_FLAG_NEW_FEATURE, options);


export const useDeleteInspectResult = (options) =>
  useMutation(DELETE_INSPECT_RESULT, options);

export const useGetForm = (options) => useQuery(GET_FORM, options);
export const useLazyGetViewStandard = (options) =>
  useLazyQuery(GET_VIEW_STANDARD, options);
export const useCreateShareStandard = (options=null) =>
  useMutation(CREATE_SHARE_STANDARD, options);
export const useEditStandard = (options) => useMutation(EDIT_STANDARD, options);

export const useLazyGetImageColorInference = (options) =>
  useLazyQuery(GET_IMAGE_COLOR_INFERENCE, options);

export const useGetListRole = (options) => useQuery(GET_LIST_ROLE, options);
export const useGetRoleById = (options) => useQuery(GET_ROLE_BY_ID, options);